import React from 'react';
import { X } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const ArticleDetailModal = ({ article, categories, onClose }) => {
    if (!article) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50 backdrop-blur-sm">
        <div className="w-full max-w-4xl max-h-[90vh] overflow-y-auto bg-white rounded-lg shadow-2xl">
          <Card className="relative bg-white">
            <button
              onClick={onClose}
              className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 bg-white shadow-md z-10"
            >
              <X className="h-6 w-6" />
            </button>
            
            <CardHeader className="bg-white border-b">
              <CardTitle className="pr-8 text-2xl">{article.title}</CardTitle>
              <div className="flex items-center justify-between text-sm text-gray-500 mt-2">
                <span>{new Date(article.dateCreated).toLocaleDateString()}</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full">
                  {categories.find(c => c.id === article.category)?.name || article.category}
                </span>
              </div>
            </CardHeader>
            
            <CardContent className="bg-white p-6">
              {article.tags?.length > 0 && (
                <div className="mb-6">
                  {article.tags.map((tag, index) => (
                    <span
                      key={index}
                      className="inline-block bg-gray-100 text-gray-800 mr-2 mb-2 px-2 py-1 rounded-full text-sm"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}
              
              <div className="prose max-w-none">
                {article.content.split('\n').map((paragraph, index) => (
                  paragraph.trim() && (
                    <p key={index} className="mb-4 text-gray-800 text-base leading-relaxed">
                      {paragraph}
                    </p>
                  )
                ))}
              </div>
              
              {article.author && (
                <div className="mt-8 pt-4 border-t text-gray-600">
                  Written by <span className="font-semibold">{article.author}</span>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    );
  };
  
  export default ArticleDetailModal;